import {connect} from "react-redux";
import {InvoiceComponent} from "./invoice.component";
import {getError} from "../../../../store/selectors/app.selectors";

const mapStateToProps = (state) => {
	return {
		error: getError(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {

	};
};

export const InvoiceSection = connect(
	mapStateToProps,
	mapDispatchToProps
)(InvoiceComponent);
